import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <path d="M6.99961 12V3.4L2.99961 7.4L1.59961 6L7.29961 0.3C7.69961 -0.1 8.29961 -0.1 8.69961 0.3L14.3996 6L12.9996 7.4L8.99961 3.4V12H6.99961ZM2 14H14V11H16V15C16 15.6 15.6 16 15 16H1C0.4 16 0 15.6 0 15V11H2V14Z" />,
  'Upload',
);
